// Angular
import {
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModal } from '@cv-invision/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'cv-public-record-modal',
	templateUrl: './public-record-modal.component.html',
	styleUrls: ['./public-record-modal.component.scss'],
})
export class PublicRecordModalComponent extends AbstractModal implements OnInit, OnDestroy {

	selected = 0;
	publicRecords: [];

	private unsubscribe = new Subject<void>();

	constructor(private router: Router) {
		super();
		this.detectNoInteraction();
	}

	ngOnInit(): void {
		this.publicRecords = this.data.publicRecords;
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	public onDismiss(): void {
		super.onCancel();
	}

	/**
	 * Update selected index
	 * @param i number
	 */
	updateSelected(i: number) {
		this.selected = i;
	}

	/**
	 * return publicRecordId and clos modal
	 * @param publicRecordId
	 */
	usAsSubjectEvent(publicRecordId: string) {
		this.onAcceptSuccess({ publicRecordId });
		this.onDismiss();
	}

	/**
	 * detect no interaction event
	 */
	detectNoInteraction() {
		this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			super.onCancel();
		})
	}
}
